import { useRouter } from "next/router";
import { Skeleton } from "ui";
import { InPlaceFilters } from "../../../components/newFilters";
import { useUserContext } from "../../../contexts/UserProvider";
import { useReportsFilters } from "../hooks/useReportsFilters";

export function ReportsFilters() {
  const router = useRouter();
  const { isMoneyHashUser } = useUserContext();

  const { filters, isLoading } = useReportsFilters();

  const applyFilter = (field: string, value: string | string[]) => {
    const cleanedValue = Array.isArray(value) ? value.filter(Boolean) : value;

    router.replace({ query: { ...router.query, [field]: cleanedValue } });
  };

  const removeFilter = (field: string) => {
    const { [field]: _removed, ...restQuery } = router.query;

    router.replace({ query: restQuery });
  };

  if (isLoading) {
    return (
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-6 w-28 rounded-lg" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex">
      <InPlaceFilters
        filters={filters}
        recentStoreKey="reports-filters"
        dateRangeMode="finiteIntervalDates"
        appliedFilters={router.query}
        customApplyFilter={applyFilter}
        customRemoveFilter={removeFilter}
        placeholders={{
          date: "Last 30 days",
          initiation: "All",
          provider_live_status: "Yes",
          method: "All methods",
          provider: "All providers",
        }}
        dependantFilter={
          isMoneyHashUser
            ? {
                name: "account",
                filterBy: "organization",
              }
            : undefined
        }
      />
    </div>
  );
}
